export enum TransactionToastEventsEnum {
  'CLOSE_TOAST' = 'CLOSE_TOAST',
  'TRANSACTION_TOAST_DATA_UPDATE' = 'TRANSACTION_TOAST_DATA_UPDATE',
}
